import type { NotificationStateRepository } from '@/features/notifications/domain/repository/notification-repository';

export async function markNotificationReadUseCase(repository: NotificationStateRepository, id: string) {
  await repository.markAsRead(id, new Date().toISOString());
}

export async function markAllNotificationsReadUseCase(repository: NotificationStateRepository, locationId: string) {
  if (!locationId) return;

  await repository.markAllAsRead(locationId, new Date().toISOString());
}
